
export default {
  name: 'icon-instagram',
};
